// src/components/Common/LoadingSpinner.jsx
const LoadingSpinner = ({ size = 'medium', fullPage = false }) => {
  const sizeClass = {
    small: 'spinner-small',
    medium: 'spinner-medium',
    large: 'spinner-large',
  }[size] || 'spinner-medium';

  const containerClass = fullPage ? 'spinner-fullpage' : 'spinner-container';

  return (
    <div className={containerClass}>
      <div className={`spinner ${sizeClass}`}></div>
    </div>
  );
};

export default LoadingSpinner;